import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SellerInvitation, SellerInvitationRole } from 'src/app/core/seller-invitations.service';
import { UtilsService } from 'src/app/core/utils.service';
import { PENDING_INVITATIONS_TABLE_COLUMNS } from 'src/app/shared/constants/operationals';

@Component({
  selector: 'app-store-details-pending-invitations-data-table',
  templateUrl: './store-details-pending-invitations-data-table.component.html',
  styleUrls: ['./store-details-pending-invitations-data-table.component.scss'],
})
export class StoreDetailsPendingInvitationsDataTableComponent {
  @Input() invitations: SellerInvitation[] = [];
  @Output() scrolledToEnd: EventEmitter<void> = new EventEmitter<void>();

  displayed_columns: string[] = PENDING_INVITATIONS_TABLE_COLUMNS;

  constructor(private utils_service: UtilsService) {}

  onScroll(event: Event) {
    const element = event.target as HTMLElement;
    const end_offset = 200;
    if (element) {
      if (element.offsetHeight + element.scrollTop >= element.scrollHeight - end_offset) {
        this.scrolledToEnd.emit();
      }
    }
  }

  getStoresNames(invitation: SellerInvitation): string {
    if (invitation.stores && invitation.stores.length > 0) {
      return invitation.stores.map(store => store.name).join(', ');
    }
    return '';
  }

  getRoleLabel(role?: string): string {
    const role_enum = role ? SellerInvitationRole[role as keyof typeof SellerInvitationRole] : undefined;
    return role_enum ? this.utils_service.getSellerInvitationRoleLabel(role_enum) : 'n/a';
  }

  getRoleClass(role?: string): string {
    const role_enum = role ? SellerInvitationRole[role as keyof typeof SellerInvitationRole] : undefined;
    return role_enum ? this.utils_service.getSellerInvitationRoleClass(role_enum) : 'n/a';
  }
}
